/**
 * pricing.ts - Pricing and subscription upgrade handling
 */

import { API_URL } from '../utils/constants';

/**
 * Show pricing modal
 */
export function showPricingModal(): void {
  const modal = document.getElementById('pricing-modal');
  if (modal) {
    modal.style.display = 'block';
  }
}

/**
 * Close pricing modal
 */
export function closePricingModal(): void {
  const modal = document.getElementById('pricing-modal');
  if (modal) {
    modal.style.display = 'none';
  }
}

/**
 * Upgrade to Pro subscription
 * @param billingPeriod - 'monthly' or 'yearly'
 */
export async function upgradeToPro(billingPeriod: 'monthly' | 'yearly'): Promise<void> {
  console.log('[UPGRADE] Starting upgrade process...', { billingPeriod, apiUrl: API_URL });

  try {
    const requestUrl = `${API_URL}/subscriptions/checkout`;
    console.log('[UPGRADE] Making POST request to:', requestUrl);

    const response = await fetch(requestUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ billingPeriod }),
    });

    console.log('[UPGRADE] Response status:', response.status);

    if (!response.ok) {
      const error = await response.json();
      console.error('[UPGRADE] API error response:', error);
      throw new Error(error.message || error.error || 'Failed to create checkout session');
    }

    const data = await response.json();
    console.log('[UPGRADE] Success response:', data);

    // Redirect to Stripe checkout
    if (data.url) {
      console.log('[UPGRADE] Redirecting to Stripe checkout:', data.url);
      window.location.href = data.url;
    } else {
      console.error('[UPGRADE] No checkout URL in response:', data);
      throw new Error('No checkout URL received');
    }
  } catch (error) {
    console.error('[UPGRADE] Caught error:', error);
    const errorPrefix = window.i18n ? window.i18n.t('upgrade.upgradeError') : 'Failed to start upgrade process';
    const errorMessage = error instanceof Error ? error.message : 'Unknown error';
    console.error('[UPGRADE] Showing alert:', `${errorPrefix}: ${errorMessage}`);
    alert(`${errorPrefix}: ${errorMessage}`);
  }
}

/**
 * Show upgrade prompt modal
 * @param title - Modal title
 * @param message - Modal message
 */
export function showUpgradePrompt(title: string, message: string): void {
  const modal = document.getElementById('upgrade-prompt-modal');
  if (!modal) return;

  const titleEl = modal.querySelector('.upgrade-prompt-title');
  const messageEl = modal.querySelector('.upgrade-prompt-message');

  if (titleEl) titleEl.textContent = title;
  if (messageEl) messageEl.textContent = message;

  modal.style.display = 'block';
}

/**
 * Close upgrade prompt modal
 */
export function closeUpgradePrompt(): void {
  const modal = document.getElementById('upgrade-prompt-modal');
  if (modal) {
    modal.style.display = 'none';
  }
}

// Make functions globally available
(window as any).showPricingModal = showPricingModal;
(window as any).closePricingModal = closePricingModal;
(window as any).upgradeToPro = upgradeToPro;
(window as any).showUpgradePrompt = showUpgradePrompt;
(window as any).closeUpgradePrompt = closeUpgradePrompt;
